import { AxiosRequestConfig } from "axios";
import { FilteredListDto } from "../base/base.dto";
import http from "../base/http.service";
import {
  ApplicationAuditPlanDto,
  CreateApplicationAuditPlanDto,
  UpdateApplicationAuditPlanDto,
  ApplicationUnitDropdownListDto,
} from "./application-audit-plans.dto";
const services = {
  GetAll(config?: AxiosRequestConfig<ApplicationAuditPlanDto> | undefined) {
    return http.get<FilteredListDto<ApplicationAuditPlanDto>>("ApplicationAuditPlans", config);
  },
  Get(id: number, config?: AxiosRequestConfig<any> | undefined) {
    return http.get<ApplicationAuditPlanDto>(`ApplicationAuditPlans/${id}`, config);
  },
  Delete(id: number, config?: AxiosRequestConfig<any> | undefined) {
    return http.remove<ApplicationAuditPlanDto>(`ApplicationAuditPlans/${id}`, config);
  },
  Add(dto: CreateApplicationAuditPlanDto, config?: AxiosRequestConfig<any> | undefined) {
    return http.post<CreateApplicationAuditPlanDto>("ApplicationAuditPlans", dto, config);
  },
  Update(dto: UpdateApplicationAuditPlanDto, config?: AxiosRequestConfig<any> | undefined) {
    return http.put<UpdateApplicationAuditPlanDto>("ApplicationAuditPlans", dto, config);
  },
  GetPlansForApplicationId(applicationId: number, config?: AxiosRequestConfig<any> | undefined) {
    return http.get<ApplicationAuditPlanDto[]>(
      `ApplicationAuditPlans/get-plans-for-applicationId/${applicationId}`,
      config
    );
  },
  GetUnitsForApplication(applicationId: number, config?: AxiosRequestConfig<any> | undefined) {
    return http.get<ApplicationUnitDropdownListDto>(
      `ApplicationAuditPlans/get-units-for-application/${applicationId}`,
      config
    );
  },
  LeadAuditorPlanApprove(applicationId: number, config?: AxiosRequestConfig<any> | undefined) {
    return http.post<ApplicationAuditPlanDto>(
      `ApplicationAuditPlans/lead-auditor-plan-approve/${applicationId}`,
      config
    );
  },
};

export default services;
